import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import axiosConfig from "../../axiosConfig";

import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";
import WarningIcon from "@material-ui/icons/Warning";
import Swal from "sweetalert2";

import { tableIcons } from "../../shared/TableIcons";
import "../Forms/Forms.css";
import AlertWidget from "../Alerts/AlertWidget";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import * as alertTypes from "../../shared/language.json";

const useStyles = makeStyles(styles);

export default function AllAlertsTakeOver(props) {
  const classes = useStyles();

  const updateAlarmStatus = () => {
    axiosConfig
      .put(`/Alarm`, props.location.alertForm)
      .then((res) => {
        if (props.location.localPath === "openAlerts") {
          history.push("/open-alerts");
        } else if (props.location.localPath === "asignedAlerts") {
          history.push("/assigned-alerts");
        } else history.push("/");
      })
      .catch((err) => {
        Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
      });
  };
  const history = useHistory();
  const tableRef = React.createRef();

  useEffect(() => {
    if (typeof props.location.data === "undefined") {
      history.push("/");
    }
  }, []);

  if (props.location.data) {
    return (
      <Card>
        <CardHeader color="warning">
          <h1 className={classes.cardTitleWhite}>
            {props.location.alertForm.statusId === 2
              ? "Ειδοποιήσεις προς ανάληψη"
              : "Ειδοποιήσεις προς κλείσιμο"}
          </h1>
        </CardHeader>
        <CardBody>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={3}>
              <AlertWidget data={props.location.alarmWidget} />
            </Grid>
            <Grid item xs={12} sm={12} md={9}>
              <MaterialTable
                icons={tableIcons}
                title={
                  props.location.alertForm.statusId === 2
                    ? "Προγενέστερες Ειδοποιήσεις προς Ανάληψη"
                    : "Προγενέστερες Ειδοποιήσεις προς Κλείσιμο"
                }
                tableRef={tableRef}
                columns={[
                  {
                    title: "Αρ. ειδοποήσης",
                    field: "id",
                  },
                  {
                    title: "IMEI συσκευής",
                    field: "imei",
                  },
                  {
                    title: "Τύπος ειδοποίησης",
                    field: "alarmType",
                  },
                  {
                    title: "Δείκτης κινδύνου",
                    field: "alarmSeverity",
                  },
                  {
                    title: "Ώρα δημιουργίας",
                    field: "dateCreated",
                  },
                  {
                    title: "Κατάσταση",
                    field: "statudId",
                    render: (rowData) =>
                      rowData.statusId ===
                        alertTypes.ALERTSTATUSID.OPENALARM ? (
                        <Chip
                          icon={<WarningIcon style={{ color: "white" }} />}
                          label="Ανοιχτή"
                          style={{ backgroundColor: "green", color: "white" }}
                        />
                      ) : rowData.statusId ===
                        alertTypes.ALERTSTATUSID.ASSIGNED ? (
                        <Chip
                          icon={<WarningIcon style={{ color: "white" }} />}
                          label="Σε Εξέλιξη"
                          style={{ backgroundColor: "orange", color: "white" }}
                        />
                      ) : rowData.statusId ===
                        alertTypes.ALERTSTATUSID.CLOSEDALARM ? (
                        <Chip
                          icon={<WarningIcon style={{ color: "white" }} />}
                          label="Κλειστή"
                          style={{ backgroundColor: "red", color: "white" }}
                        />
                      ) : (
                        <div />
                      ),
                  },
                ]}
                data={props.location.data}
                localization={{
                  body: {
                    emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
                  },
                  pagination: {
                    firstTooltip: "Πρώτη Σελίδα",
                    lastTooltip: "Τελευταία Σελίδα",
                    previousTooltip: "Προηγούμενη Σελίδα",
                    nextTooltip: "Επόμενη Σελίδα",
                    labelDisplayedRows: "{from}-{to} από {count}",
                    labelRowsSelect: "Εγγραφές ανά Σελίδα",
                  },
                  toolbar: {
                    searchTooltip: "Αναζήτηση",
                    searchPlaceholder: "Αναζήτηση",
                  },
                  grouping: {
                    placeholder: "Σύρετε για να ομαδοποιήσετε",
                    groupedBy: "Σύρετε για να ομαδοποιήσετε",
                  },
                }}
                actions={[
                  {
                    icon: () => (
                      <Chip
                        label={
                          props.location.data.length > 1
                            ? "Υπάρχουν " +
                            props.location.data.length +
                            " ειδοποιήσεις"
                            : props.location.data.length === 1
                              ? "Υπάρχει " +
                              props.location.data.length +
                              " ειδοποιήση"
                              : "Δεν υπάρχουν άλλες ειδοποιήσεις"
                        }
                        style={{ backgroundColor: "#E24E42", color: "white" }}
                      />
                    ),
                    isFreeAction: true,
                  },
                ]}
                options={{
                  grouping: true,
                  sorting: true,
                }}
              />
              <Grid
                item
                sm={12}
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "2vh",
                }}
              >
                {props.location.data.length > 0 ? (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      Swal.fire({
                        title: "",
                        text:
                          (props.location.alertForm.statusId === 2)
                            ? `Θέλετε να αναλάβετε όλες τις προγενέστερες Ανοιχτες Ειδοποιήσεις του Ωφελούμενου με κωδικό ${props.location.alertForm.id};`
                            : `Θέλετε να κλείσετε όλες τις προγενέστερες Ειδοποιήσεις Σε Εξέλιξη του Ωφελούμενου με κωδικό ${props.location.alertForm.id};`,
                        icon: "warning",
                        position: "center",
                        showCancelButton: true,
                        container: "container-class",
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Ναι",
                        cancelButtonText: "Οχι",
                      }).then((result) => {
                        if (result.value) {
                          props.location.alertForm.isMassive = true;
                          if (result.isConfirmed) {
                            Swal.fire({
                              title: "",
                              text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας.",
                              icon: "warning",
                              position: "center",
                              showCancelButton: true,
                              container: "container-class",
                              confirmButtonColor: "#3085d6",
                              cancelButtonColor: "#d33",
                              confirmButtonText: "Ναι",
                              cancelButtonText: "Οχι",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                updateAlarmStatus();
                              }
                            });
                          }
                        } else {
                          props.location.alertForm.isMassive = false;
                          Swal.fire({
                            title: "",
                            text:
                              props.location.alertForm.statusId === 2
                                ? `Θέλετε να αναλάβετε την Ειδοποίηση με Αριθμό ${props.location.alarmWidget.id};`
                                : `Θέλετε να κλείσετε την Ειδοποιήση με Αριθμό ${props.location.alarmWidget.id};`,
                            icon: "warning",
                            position: "center",
                            showCancelButton: true,
                            container: "container-class",
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Ναι",
                            cancelButtonText: "Οχι",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              Swal.fire({
                                title: "",
                                text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας.",
                                icon: "warning",
                                position: "center",
                                showCancelButton: true,
                                container: "container-class",
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Ναι",
                                cancelButtonText: "Οχι",
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  updateAlarmStatus();
                                }
                              });
                            }
                          });
                        }
                      });
                    }}
                  >
                    Συνεχεια
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      Swal.fire({
                        title: "",
                        text:
                          props.location.alertForm.statusId === 2
                            ? `Θέλετε να αναλάβετε την Ειδοποίηση με Αριθμό ${props.location.alarmWidget.id};`
                            : `Θέλετε να κλείσετε την Ειδοποιήση με Αριθμό ${props.location.alarmWidget.id};`,
                        icon: "warning",
                        position: "center",
                        showCancelButton: true,
                        container: "container-class",
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Ναι",
                        cancelButtonText: "Οχι",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          Swal.fire({
                            title: "",
                            text: "Παρακαλούμε επιβεβαιώστε την καταχώρηση σας.",
                            icon: "warning",
                            position: "center",
                            showCancelButton: true,
                            container: "container-class",
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Ναι",
                            cancelButtonText: "Οχι",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              updateAlarmStatus();
                            }
                          });
                        }
                      });
                    }}
                  >
                    Συνεχεια
                  </Button>
                )}

              </Grid>
            </Grid>
          </Grid>
        </CardBody>
      </Card>
    );
  } else {
    return <div />;
  }
}
